import { AbstractOrchestrationFacade } from '../../common';
import { ReadLocationDto } from '../generated-dto';
export class MerchantLocationFacade extends AbstractOrchestrationFacade {
    constructor() {
        super(...arguments);
        this.baseUrl = (merchantId) => `api/v1/merchants/${encodeURIComponent(merchantId)}/locations`;
    }
    async includeLocations(merchantId, payload) {
        return this.toDto(await this.client.post(this.baseUrl(merchantId), payload), ReadLocationDto);
    }
    async listLocations(merchantId) {
        return this.toDto(await this.client.get(this.baseUrl(merchantId)), ReadLocationDto);
    }
    async excludeLocations(merchantId, payload) {
        await this.client.delete(this.baseUrl(merchantId), { data: payload });
    }
}
//# sourceMappingURL=MerchantLocationFacade.js.map